




































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import BrandsStore from "@/mixins/brandsStore";
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { DiscountTypes } from "@/data/enums/promotions";
import { ProductTypes } from "@/data/enums/products";

// Types
import { IPromotionProduct, IPromotionFormProduct } from "@/models/promotions";

@Component({
  components: {
    "discount-and-conditions": () =>
      import(
        "@/components/app/admin/catalogue/promotions/discountAndConditions.vue"
      ),
    "select-product-with-preview": () =>
      import(
        "@/components/app/admin/catalogue/promotions/selectProductWithPreview.vue"
      )
  }
})
export default class ManageProductModal extends Mixins(
  RequestPromises,
  BrandsStore,
  HasValidation
) {
  // Props
  @Prop({ default: () => ({}) })
  public promotionProduct!: IPromotionProduct;

  @Prop({ default: null })
  public productId!: IPromotionProduct["product_id"];

  // Data
  public isProcessing = false;
  public isInitialised = false;

  public form: IPromotionFormProduct = {
    product_id: undefined,
    amount: 0,
    billing_cycles: [],
    max_quantity: undefined,
    min_quantity: undefined,
    pricelists: [],
    type: DiscountTypes.MONEY_BASED
  };
  public formClone = {} as IPromotionFormProduct;

  public productTypes: ProductTypes[] = [
    ProductTypes.SINGLE_PRODUCT,
    ProductTypes.PRODUCT_BUNDLE
  ];

  // Lifecycle methods
  public async created() {
    this.refreshForm();
    this.isInitialised = true;
  }

  // Getters

  public get formIsDisabled() {
    return this.isProcessing || !this.formIsValid || this.hasErrors;
  }

  public get formIsValid() {
    if (!this.$_.isEqual(this.form, this.formClone)) return true;
    return false;
  }

  public get isUpdate() {
    return !this.$_.isEmpty(this.promotionProduct);
  }

  public get title() {
    if (!this.isUpdate) return this.$t("_.attach_and_configure_product");
    return this.$t("_.update_attached_product");
  }

  // Methods
  public async validateBeforeSubmit() {
    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }

      this.isProcessing = true;

      this.$emit("success", this.form);
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public refreshForm() {
    if (this.isUpdate) {
      this.form = this.$_.merge(
        {},
        this.form,
        this.$_.pick(this.promotionProduct, [
          "id",
          "product_id",
          "name",
          "order",
          "amount",
          "currency_id",
          "currencies",
          "billing_cycles",
          "pricelists",
          "min_quantity",
          "max_quantity",
          "type"
        ])
      );
    } else {
      this.$set(this.form, "currency_id", this.brandCurrencyId);
    }

    if (this.productId) {
      this.$set(this.form, "product_id", this.productId);
    }

    this.formClone = this.$_.cloneDeep(this.form);
  }
}
